import { atom } from "jotai";

// Whether the home HUD (navigation, chat, audio controls) should be visible.
export const homeUiReadyAtom = atom(false);

// Write-only setter to toggle the home HUD visibility flag.
export const setHomeUiReadyAtom = atom(null, (_get, set, isReady: boolean) => {
  set(homeUiReadyAtom, isReady);
});

// Whether the TeleportWidget navigation dialog is open. Shared so the bottom
// navbar can trigger the same dialog as the floating button.
export const teleportDialogOpenAtom = atom(false);

// Whether the WelcomePackDialog is currently open. Shared so the lobby tour
// gate can avoid starting a tour while the welcome pack flow is active —
// otherwise the nextstepjs prevent-click overlay blocks the dialog's button.
export const welcomePackDialogOpenAtom = atom(false);
